import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.to-string";

const registerStoreModule = function registerStoreModule(store, moduleName, moduleObject) {
  let preserve = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!Object.keys(store.getters).toString().includes(moduleName)) {
    store.registerModule(moduleName.replace('/', ''), moduleObject, {
      preserveState: preserve
    });
  }
};

export default registerStoreModule;